import Model from '@/models/Model'

export default class AuditHistoricPrice extends Model {
    resource() {
        return 'accounting_bank_card_chile'
    }
}